import React, { useState } from 'react';
import './ObjectStorageDemo.css';
import s3Icon from './amazon-s3-simple-storage-service.svg';

const awsOrange = '#FF9900';

const randomFile = () => {
  const names = ['photo.jpg', 'report.pdf', 'data.csv', 'backup.zip', 'video.mp4'];
  const name = names[Math.floor(Math.random() * names.length)];
  const size = Math.floor(Math.random() * 900 + 100) + ' KB';
  const id = Math.random().toString(36).substring(2, 8);
  return { name, size, id };
};

const ObjectStorageDemo: React.FC = () => {
  const [objects, setObjects] = useState<{ name: string; size: string; id: string }[]>([]);

  const handleUpload = () => {
    setObjects([...objects, randomFile()]);
  };

  return (
    <div className="object-demo-container wide">
      <div className="object-demo-header">
        <img src={s3Icon} alt="AWS S3 Icon" className="aws-s3-icon" />
        <h2 className="object-demo-title">S3 Object Storage</h2>
      </div>
      <div className="object-demo-desc">
        Object storage stores data as objects with metadata and unique IDs. Ideal for backups, media, and unstructured data.
      </div>
      <div className="object-demo-cloud">
        {objects.map((obj, i) => (
          <div className="object-demo-object" key={obj.id + i}>
            <div className="object-demo-object-name">{obj.name}</div>
            <div className="object-demo-object-meta">{obj.size} | ID: {obj.id}</div>
          </div>
        ))}
        <div className="object-demo-cloud-bg">☁️</div>
      </div>
      <button className="object-demo-upload" onClick={handleUpload}>Upload File</button>
    </div>
  );
};

export default ObjectStorageDemo; 